import { useEffect, useState } from 'react';
import { Button } from '../../../../../core/components/atoms/Button';
import { Typography } from '../../../../../core/components/molecules/Typography';
import Exercise from '../../../../../core/components/templates/Exercise';
import { Modal } from '../../../../../core/components/templates/Modal';
import { useUserStore } from '../../../../Auth/stores/authStore';
import { useRevisionExercises } from '../../../hooks/Revision/exercises';
import Confetti from 'react-confetti';
import { ExerciseAction, IExercise } from '../../../../../core/models/exercise';
import { PopUpModal } from '../../../../Gamification/components/Playing/PopUpModal';
import { useShouldShowPopUpScore } from '../../../../../core/hooks/useShouldShowPopUpScore';

const RevisionExercises = () => {
  const { user } = useUserStore();
  const { shouldShowPopUpScore } = useShouldShowPopUpScore();

  const {
    subject,
    exercises,
    isPending,
    totalCorrectAnswers,
    showConfirmationModal,
    isRight,
    isFinishingRevision,
    changeExercise,
    updateExercise,
    handleFinishRevision,
    setShowConfirmationModal,
  } = useRevisionExercises();

  const [showModalScore, setShowModalScore] = useState<number | false>(false);
  const [action, setAction] = useState<ExerciseAction | undefined>(undefined);

  const handleExerciseChange = (
    exercise: IExercise,
    action?: ExerciseAction
  ) => {
    setAction(action);
    updateExercise(exercise, action);
  };

  useEffect(() => {
    if (isRight) {
      const audio = new Audio(
        'https://storage.aprovatotal.com.br/platform-storage-prod/sounds/songCorrectExercise.mp3'
      );
      if (user && user.exercisePlaySound) {
        audio.play();
      }
    }

    if (action === 'verifyAnswer' && shouldShowPopUpScore) {
      setShowModalScore(isRight ? 2 : 1);
    }
    setAction(undefined);
  }, [isRight, action, shouldShowPopUpScore]);

  return (
    <>
      {isRight && user?.exerciseShowAnimation && (
        <Confetti
          width={window.innerWidth - 20}
          height={document.body.clientHeight}
          numberOfPieces={300}
        />
      )}
      <Exercise
        exercises={exercises}
        exerciseType='revision'
        onExerciseChange={(exercise, action) => {
          handleExerciseChange(exercise, action);
        }}
        onPageChange={(page) => changeExercise(page)}
        onEndRevision={() => {
          setShowConfirmationModal(true);
        }}
        isLoading={isPending}
      />
      <Modal
        isOpen={showConfirmationModal}
        onClose={() => setShowConfirmationModal(false)}
        position='center'
        className='w-2/5 p-0'
      >
        <div className='flex flex-col gap-xl'>
          {totalCorrectAnswers >= 2 ? (
            <>
              <Typography type='p'> Parabéns!</Typography>
              <Typography type='p'>
                Você quer continuar revisando questões sobre esse assunto?
              </Typography>
              <Typography type='p'>
                Se quiser continuar a revisão, você poderá revisar o assunto{' '}
                {subject} em 2 dias.
              </Typography>
              <div className='flex flex-row items-center justify-end gap-sm'>
                <Button
                  variant='text'
                  loading={isFinishingRevision}
                  onClick={() => handleFinishRevision(true)}
                >
                  <Typography>Continuar revisando</Typography>
                </Button>

                <Button
                  variant='text'
                  loading={isFinishingRevision}
                  onClick={() => handleFinishRevision()}
                >
                  <Typography>Encerrar revisão</Typography>
                </Button>
              </div>
            </>
          ) : totalCorrectAnswers == 1 ? (
            <>
              <Typography type='p'>
                Você acertou 1 de 2 questões sobre o assunto {subject}.
              </Typography>
              <Typography type='p'>
                Você ainda precisa revisar esse assunto um pouco mais.
              </Typography>
              <div className='flex items-center justify-end'>
                <Button
                  variant='text'
                  loading={isFinishingRevision}
                  onClick={() => handleFinishRevision()}
                >
                  <Typography>Revisar em 2 (dois) dias</Typography>
                </Button>
              </div>
            </>
          ) : (
            <>
              <Typography type='p'>
                Você não acertou nenhuma questão sobre o assunto {subject}.
              </Typography>
              <Typography type='p'>
                Você ainda precisa revisar esse assunto um pouco mais.
              </Typography>
              <div className='flex items-center justify-end'>
                <Button
                  variant='text'
                  loading={isFinishingRevision}
                  onClick={() => handleFinishRevision()}
                >
                  <Typography>Revisão disponível amanhã</Typography>
                </Button>
              </div>
            </>
          )}
        </div>
      </Modal>
      {showModalScore && (
        <PopUpModal
          isOpen={!!showModalScore}
          onClose={() => setShowModalScore(false)}
          score={showModalScore}
        />
      )}
    </>
  );
};

export default RevisionExercises;
